import React, { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd-cjs';
const DndSortableElement = ({ dndType, dndAcceptType, children, id, position, onDrop, onHover, onDragBegin, onDragEnd, isSortable = true })=>{
    const ref = useRef(null);
    const [{ handlerId, isOver }, drop] = useDrop({
        accept: dndAcceptType || dndType,
        collect (monitor) {
            return {
                handlerId: monitor.getHandlerId(),
                isOver: monitor.isOver()
            };
        },
        drop: (item)=>{
            if (!ref.current) {
                return;
            }
            onDrop(position);
        },
        hover (item) {
            if (!ref.current) {
                return;
            }
            if (id !== item.id) {
                onHover(position);
            }
        },
        canDrop (item, monitor) {
            return isSortable;
        }
    });
    const [{ isDragging }, drag] = useDrag({
        item: {
            type: dndType
        },
        begin: ()=>{
            onDragBegin(id, position);
        },
        end: ()=>{
            onDragEnd();
        },
        canDrag: isSortable,
        collect: (monitor)=>{
            return {
                isDragging: monitor.isDragging()
            };
        }
    });
    drag(drop(ref));
    return children({
        ref,
        'data-handler-id': handlerId,
        isDragging,
        isOver
    });
};
DndSortableElement.displayName = 'DndSortableElement';
export default DndSortableElement;

//# sourceMappingURL=DndSortableElement.js.map